import { Stack } from '@mui/material'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { MinimalAPIError } from 'components/core/errors/api'
import { C1EntitlementDisplayNameWithFetch } from 'components/pages/entitlement/display-name'
import { TaskValue } from 'lib/actions/task'
import { FC } from 'react'
import { getAppEntitlementUserBindingApi } from 'redux_toolkit/entitlements'

type TaskInheritedEntitlementWithFetchProps = {
    task: TaskValue
}

export const TaskInheritedEntitlementWithFetch: FC<TaskInheritedEntitlementWithFetchProps> = ({ task }) => {
    if (!task.app || !task.appEntitlements || !task.appUser) return <C1EmptyIndicator />

    const { data, error } = getAppEntitlementUserBindingApi.useGet({
        appId: task.app.id,
        appEntitlementId: task.appEntitlements[0].id,
        appUserId: task.appUser.id,
    })

    if (!data || !data.grantSources || !data.grantSources.length) return <C1EmptyIndicator />

    if (error) return <MinimalAPIError err={error.message} />

    return <Stack spacing={2}>
        {data.grantSources.map((grantSource) => <C1EntitlementDisplayNameWithFetch
            key={`${grantSource.id}:${grantSource.appId}`}
            entitlementId={grantSource.id}
            appId={grantSource.appId}
        />)}
    </Stack>
}
